import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { EmployeeUtilizationReportTable } from './EmployeeUtilizationReportTable';
import './EmployeeUtilizationReport.scss';

const getDefaultFilters = () => {
  const endDate = dayjs().startOf('day');
  const startDate = endDate.startOf('month');

  return {
    projectId: '',
    startDate,
    endDate,
  };
};

const formatDateRangePayload = (filters = {}) => ({
  startDate: dayjs(filters.startDate).isValid()
    ? dayjs(filters.startDate).format('YYYY-MM-DD')
    : undefined,
  endDate: dayjs(filters.endDate).isValid()
    ? dayjs(filters.endDate).format('YYYY-MM-DD')
    : undefined,
});

const buildRequestPayload = (filters = {}, projectOptions = []) => {
  return {
    projectId: filters.projectId || undefined,
    projectName: projectOptions.find((project) => project.id === filters.projectId)?.name || undefined,
  };
};

const cloneFilters = (filters = {}) => ({
  projectId: filters.projectId || '',
  startDate: dayjs(filters.startDate).isValid()
    ? dayjs(filters.startDate).startOf('day')
    : null,
  endDate: dayjs(filters.endDate).isValid()
    ? dayjs(filters.endDate).startOf('day')
    : null,
});

const EmployeeUtilizationReport = () => {
  const [defaultFilters] = useState(() => cloneFilters(getDefaultFilters()));
  const [draftFilters, setDraftFilters] = useState(() => cloneFilters(defaultFilters));
  const [appliedFilters, setAppliedFilters] = useState(() => cloneFilters(defaultFilters));
  const [initialDateRange, setInitialDateRange] = useState(() => (
    formatDateRangePayload(defaultFilters)
  ));
  const [projectOptions] = useState([]);
  const [error, setError] = useState('');
  const [tableResetKey, setTableResetKey] = useState(0);

  const selectedProject = useMemo(
    () => projectOptions.find((project) => project.id === draftFilters.projectId) || null,
    [draftFilters.projectId, projectOptions],
  );

  const selectedProjectName = selectedProject?.name || '';

  const reportPayload = useMemo(
    () => buildRequestPayload(appliedFilters, projectOptions),
    [appliedFilters, projectOptions],
  );

  const handleResetFilters = () => {
    const nextDefaultFilters = cloneFilters(defaultFilters);
    setDraftFilters(nextDefaultFilters);
    setAppliedFilters(cloneFilters(defaultFilters));
    setInitialDateRange(formatDateRangePayload(defaultFilters));
    setError('');
    setTableResetKey((previousKey) => previousKey + 1);
  };

  return (
    <div className="employee-utilization-report-page-outer-layer employee-utilization-report-page">
      <div className="employee-utilization-report-page-layout employee-utilization-report-page-content">
        {selectedProjectName && (
          <div className="employee-utilization-report-page-selection">
            {selectedProjectName}
          </div>
        )}

        {error && (
          <div className="employee-utilization-report-page-message employee-utilization-report-page-message-error">
            {error}
          </div>
        )}

        <EmployeeUtilizationReportTable
          key={tableResetKey}
          appliedFilters={reportPayload}
          initialDateRange={initialDateRange}
          onRefresh={handleResetFilters}
        />
      </div>
    </div>
  );
};

export default EmployeeUtilizationReport;
